export enum EnumOptionGranularity {
  ARTICLE = 'ARTICLE',
  SERVICE = 'SERVICE'
}